module.exports = __webpack_public_path__ + "static/media/mobileViewBack@2x.81082041.png";